module.exports = __webpack_public_path__ + "img/complate.3fc81bfc.png";